module.exports = __webpack_public_path__ + "img/sgyl.594ad76f.png";